<div class="step">Paso X de Y</div>
<div class="title" i18n>Done!</div>
<div class="subtitle" i18n>Your invitation request has been sent.</div>
<div class="extra-line" i18n>
  You will receive an email when your invitation request has been accepted.
</div>
